import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import {
  Languages,
  FlaskConical,
  Newspaper,
  Flag,
  Globe,
  Landmark,
  TrendingUp,
  Calculator,
} from "lucide-react";

const ICONS = [Languages, FlaskConical, Newspaper, Flag, Globe, Landmark, TrendingUp, Calculator];
const COLORS = [
  "bg-amber-100 text-amber-700",
  "bg-blue-100 text-blue-700",
  "bg-purple-100 text-purple-700",
  "bg-red-100 text-red-700",
  "bg-emerald-100 text-emerald-700",
  "bg-pink-100 text-pink-700",
  "bg-orange-100 text-orange-700",
  "bg-teal-100 text-teal-700",
];

const Subjects = () => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="subjects-section"
      className="relative py-24 sm:py-28 bg-gradient-to-b from-transparent via-[#f8f4ec] to-transparent"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600">
              {t.subjects.eyebrow}
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.05]">
              {t.subjects.title}
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-md">
              {t.subjects.subtitle}
            </p>
            <div className="mt-7 flex items-center gap-3">
              <span className="text-3xl font-black text-blue-950">2,000+</span>
              <span className="text-sm text-slate-600 leading-tight">
                questions per subject
                <br />
                <span className="text-xs text-slate-500">
                  with detailed AI explanations
                </span>
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
              {t.subjects.list.map((name, i) => {
                const Icon = ICONS[i];
                return (
                  <div
                    key={name}
                    data-testid={`subject-card-${i}`}
                    className="card-lift bg-white border border-blue-900/10 rounded-2xl p-4 sm:p-5"
                  >
                    <div
                      className={`h-10 w-10 sm:h-11 sm:w-11 rounded-xl ${COLORS[i]} flex items-center justify-center`}
                    >
                      <Icon size={20} strokeWidth={2.2} />
                    </div>
                    <p className="mt-3 font-bold text-sm sm:text-base text-blue-950 leading-tight">
                      {name}
                    </p>
                    <p className="mt-1 text-[11px] text-slate-500 font-semibold tracking-wider uppercase">
                      2000+ Q
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subjects;
